module.exports = __webpack_public_path__ + "img/Barcode.38be6eda.png";